import React from 'react';
import { Link } from 'react-router-dom';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

const NotFound: React.FC = () => {
  return (
    <Box 
      sx={{ 
        display: 'flex', 
        flexDirection: 'column', 
        alignItems: 'center', 
        justifyContent: 'center', 
        height: '70vh', 
        textAlign: 'center' 
      }}
    >
      <WarningAmberIcon sx={{ fontSize: 80, color: 'warning.main', mb: 3 }} />
      <Typography variant="h2" component="h1" gutterBottom>
        404 - ページが見つかりません
      </Typography>
      <Typography variant="h6" sx={{ mb: 4, maxWidth: 'sm' }}>
        お探しのページは存在しないか、移動された可能性があります。
        URLを確認するか、以下のボタンからダッシュボードにお戻りください。
      </Typography>
      <Link to="/" style={{ textDecoration: 'none' }}>
        <Button variant="contained" size="large" startIcon={<ArrowBackIcon />}>
          ダッシュボードに戻る
        </Button>
      </Link>
    </Box>
  );
};

export default NotFound;